import api from '../api';

function findAll() {
  return new Promise((resolve, reject) => {
    return api.get('/countries')
      .then(response => resolve(response))
      .catch(error => reject(error));
  });
}


export default {
  findAll,
};